import { ExternalUrlValue } from "app/area/external-url-groups/form/types-store";
import { parseAsDateUTC } from "app/infrastructure/data/date";
import { Value } from "app/types-shared";

export interface ExternalUrlWireFormat extends Value {
  disabled?: string;
  urlTemplate?: string;
}

export const externalUrlItemToStoreValue = (wire: ExternalUrlWireFormat): ExternalUrlValue => {

  if (!wire) {
    return undefined;
  }

  const rawValue: ExternalUrlValue = {
    value: wire.v,
    description: wire.d,
    longDescription: wire.ld,
    allLevelDescription: wire.ald,
    disabled: !!wire.disabled ? parseAsDateUTC(wire.disabled) : undefined,
    urlTemplate: wire?.urlTemplate
  };

  const value = Object.keys(rawValue).reduce((ret, key) => {
    if (rawValue[key] !== undefined) {
      ret[key] = rawValue[key];
    }
    return ret;
  }, {} as ExternalUrlValue);

  return Object.keys(value).length ? value : undefined;
};
